<section mat-dialog-title>
  <span class="test-title">{{ data.workflow ? 'Edit' : 'Create' }} Workflow</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
<mat-dialog-content class="test-description">
  <form
    id="workflow-form"
    (ngSubmit)="submit()"
    [formGroup]="form"
  >
    <div>
      <label
        class="input-main-label capitalize block mt-0 mb-1"
        for="name"
      >Workflow Name *</label>
      <mat-form-field
        class="input-classic w-full"
        appearance="outline"
      >
        <input
          id="name"
          type="text"
          formControlName="name"
          matInput
          placeholder="Enter Workflow Name"
        />
        <mat-error>Input is not valid</mat-error>
      </mat-form-field>
    </div>

    <avs-datapoint-picker
      [realtimeAttributes]="realtimeAttributes()"
      formControlName="dataPoint"
    />

    <div class="flex">
      <avs-operator formControlName="operator" />
      <avs-condition-picker
        class="flex-1"
        formControlName="conditionValue"
      />
    </div>

    <div class="flex w-full mb-4">
      <span class="flex items-center justify-center h-10 min-w-[108px] rounded-md border border-ui-gray-light bg-ui-gray-900 text-ui-dark  text-xl font-semibold mr-5 mt-[26px]">THEN</span>
      <div class="w-full">
        <div class="flex w-full">
          <div class="w-full">
            <label
              class="input-main-label block mt-0 mb-1"
              for="deviceActionId"
            >
              Device Action *
            </label>
            <mat-form-field
              class="select-classic has-validation w-full -mb-2.5"
              appearance="outline"
            >
              <mat-select
                id="deviceActionId"
                formControlName="actionPointId"
                panelClass="single-select-overlay"
                placeholder="Select device action"
              >
                @if (device()?.actionPoints?.length) {
                  <mat-optgroup label="Action Points">
                    @for (attribute of device()?.actionPoints || [] | sort : 'asc' : 'name'; track attribute.id) {
                      <mat-option [value]="attribute.id">
                        {{ attribute.name }}
                      </mat-option>
                    }
                  </mat-optgroup>
                }
                @if (remoteActions().length) {
                  <mat-optgroup label="Remote Actions">
                    @for (action of remoteActions() | sort : 'asc' : 'name'; track action.id) {
                      <mat-option [value]="action.id">
                        {{ action.name }}
                      </mat-option>
                    }
                  </mat-optgroup>
                }
              </mat-select>
              <mat-icon
                class="arrow-down"
                fontIcon="keyboard_arrow_down"
                matSuffix
              />
            </mat-form-field>
          </div>
        </div>

        @if (form.value.actionPointId && selectedActionPoint()) {
          <div>
            <label
              class="input-main-label capitalize block mt-0 mb-1"
              for="value"
            >
              Value
            </label>
            <avs-action-point-value-selector
              (valueChanged)="form.patchValue({ value: $event })"
              [actionPoint]="selectedActionPointRequired()"
            />
          </div>
        }
      </div>
    </div>

    <div class="flex">
      <div class="w-1/2 mr-2.5">
        <label
          class="input-main-label capitalize block mt-0 mb-1"
          for="max-attempts"
        >Max Attempts *</label>
        <mat-form-field
          class="input-classic w-full"
          appearance="outline"
        >
          <input
            id="max-attempts"
            type="number"
            formControlName="maxAttempts"
            matInput
            placeholder="Enter Maximum Attempts"
          />
          <mat-error>Input is not valid</mat-error>
        </mat-form-field>
      </div>
      <div class="w-1/2 ml-2.5">
        <label
          class="input-main-label capitalize block mt-0 mb-1 w-full"
          for="timeout-between-attempts"
        >Timeout Between Attempts, sec *</label>
        <mat-form-field
          class="input-classic w-full"
          appearance="outline"
        >
          <input
            id="timeout-between-attempts"
            type="number"
            formControlName="timeoutBetweenAttempts"
            matInput
            placeholder="Enter Timeout Between Attempts"
          />
          <mat-error>Input is not valid</mat-error>
        </mat-form-field>
        @if (formattedTimeout()) {
          <p class="text-ui-gray-100 font-semibold text-sm -mt-5">{{ formattedTimeout() }}</p>
        }
      </div>
    </div>
    @if ('workflow-schedule' | avsFeatureFlag) {
      <avs-schedule-control formControlName="schedule" />
    }

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.workflow) {
    <button
      class="btn-medium font-bold btn-red mr-auto"
      (click)="deleteWorkflow()"
      [disabled]="workflowStore.isDeleting() || workflowStore.isUpdatingOrCreating()"
    >
      @if (workflowStore.isDeleting()) {
        <mat-spinner
          class="mr-1"
          diameter="20"
        />
      }
      DELETE
    </button>
  }
  <button
    class="btn-transparent btn-medium font-bold mr-4"
    mat-dialog-close
  >CANCEL
  </button>
  <button
    type="submit"
    class="btn-green btn-medium font-bold"
    [disabled]="workflowStore.isUpdatingOrCreating() || workflowStore.isDeleting()"
    form="workflow-form"
  >
    @if (workflowStore.isUpdatingOrCreating()) {
      <mat-spinner
        class="mr-1"
        diameter="20"
      ></mat-spinner>
    }
    {{ data.workflow ? 'SAVE' : 'CREATE' }}
  </button>
</mat-dialog-actions>
